import { writable } from "svelte/store";

export type ThemeMode = "system" | "light" | "dark";

const STORAGE_KEY = "crane_theme";

/**
 * A personal viewing preference, not a project setting — kept in localStorage, not
 * synced through PocketBase (unlike allowWeekendWork/subcontractorColors, which every
 * viewer of the project should see the same way).
 */
function readStored(): ThemeMode {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

/** "system" removes the override so the existing `@media (prefers-color-scheme)` rules decide. */
function apply(mode: ThemeMode) {
  if (mode === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", mode);
}

function createThemeStore() {
  const { subscribe, set: rawSet } = writable<ThemeMode>(readStored());
  function set(mode: ThemeMode) {
    try { localStorage.setItem(STORAGE_KEY, mode); } catch { /* ignore */ }
    apply(mode);
    rawSet(mode);
  }
  return { subscribe, set };
}

/** index.html applies the stored value before first paint, so no flash on load. */
export const theme = createThemeStore();
